import React, {Fragment, useContext, useState} from "react";
import {FormattedMessage} from "react-intl";
import Api from "../../Api";
import Empty from "./Empty";
import TableRow from "./TableRow";
import Modal from "../Utils/Modal";
import Amount from "../Utils/Amount";
import {InputAmountCurrencyHelper} from "../Utils/FieldsHelper";
import Loader from "../Utils/Loader";
import classes from "./styles.module.css";
import MessageContext from "../../MessageContext";

function TransactionsTable({transactions, isLoading, token, adminPrivileges}) {
    const {onMessage} = useContext(MessageContext);
    const [isOpened, setIsOpened] = useState(false);
    const [transactionData, setTransactionData] = useState({
        id: null,
        accountingDate: null,
        amount: null,
        currency: null,
        canUsePartialRefund: null,
        canUsePartialReversal: null,
    });
    const [cancelTransactionData, setCancelTransactionData] = useState({currentId: null, cancelId: null});
    const [cancelInProcess, setCancelInProcess] = useState({inProcess: false, id: null});
    const [amount, setAmount] = useState(0);

    function onTransactionCancel(id, accountingDate, amount, currency, canUsePartialRefund, canUsePartialReversal) {
        setIsOpened(true);
        setTransactionData({id, accountingDate, amount, currency, canUsePartialRefund, canUsePartialReversal});
        setAmount(amount);
        setCancelInProcess({...cancelInProcess, id});
    }

    function onCancelConfirm() {
        setIsOpened(false);
        setCancelInProcess({...cancelInProcess, inProcess: true});

        new Api({token})
            .makeTransactionCancel(transactionData.id, amount)
            .then((r) => {
                if (r.error) {
                    onMessage({
                        type: "error",
                        message: <FormattedMessage id="TransactionsTable.cancel.error"
                                                   defaultMessage="Отмена платежа невозможна"/>
                    });
                } else if (r.code) {
                    onMessage({type: "error", message: `(Code: ${r.code}): ${r.message}`});
                } else {
                    onMessage({
                        type: "success",
                        message: <FormattedMessage id="TransactionsTable.cancel.success"
                                                   defaultMessage="Отмена инициирована"/>
                    });
                    setCancelTransactionData({currentId: transactionData.id, cancelId: r.id});
                }
            })
            .finally(() => setCancelInProcess({...cancelInProcess, inProcess: false}));
    }

    return (
        <Fragment>
            <Modal
                title={<FormattedMessage id="TransactionsTable.modal.title" defaultMessage="Подтвердите действие"/>}
                isOpen={isOpened}
                onClose={() => setIsOpened(false)}
                onConfirm={onCancelConfirm}
                isConfirm
            >
                {transactionData.accountingDate ? (
                    transactionData.canUsePartialRefund ? (
                        <Fragment>
                            <p className={classes.ModalText}>
                                <FormattedMessage
                                    id="TransactionsTable.text.paymentPartialRefund"
                                    values={{
                                        amount: <b><Amount amount={transactionData.amount}
                                                           currency={transactionData.currency}/></b>
                                    }}
                                    defaultMessage="По данной операции доступен частичный возврат. Максимальная сумма {amount}. Время возврата зависит от банка-эмитента и составляет от 1 до 7 рабочих дней."
                                />
                            </p>
                            <div className={classes.CancelWrap}>
                                <InputAmountCurrencyHelper
                                    onChange={(val) => setAmount(val.amount)}
                                    value={amount}
                                    currency={[transactionData.currency]}
                                    maxValue={transactionData.amount}
                                    placeholder={transactionData.amount}
                                    label={<FormattedMessage id="FieldsHelper.label.amount" defaultMessage="Сумма"/>}
                                    changeMessage={<FormattedMessage id="FieldsHelper.error.onlyNumbersAmount"
                                                                     defaultMessage="Сумма содержит только цифры и знак «.». Например: 100.20"/>}
                                    blurMessage={<FormattedMessage id="FieldsHelper.error.checkAmount"
                                                                   defaultMessage="С суммой что-то не так. Проверьте и попробуйте еще раз. Например: 100.20"/>}
                                    isDisabled={cancelInProcess.inProcess}
                                />
                            </div>
                        </Fragment>
                    ) : (
                        <FormattedMessage
                            id="TransactionsTable.text.paymentRefund"
                            values={{
                                amount: <b><Amount amount={transactionData.amount} currency={transactionData.currency}/></b>
                            }}
                            defaultMessage="Будет осуществлен возврат на сумму {amount}. Время возврата зависит от банка-эмитента и составляет от 1 до 7 рабочих дней."
                        />
                    )
                ) : transactionData.canUsePartialReversal ? (
                    <Fragment>
                        <p className={classes.ModalText}>
                            <FormattedMessage
                                id="TransactionsTable.text.paymentPartialReversal"
                                values={{
                                    amount: <b><Amount amount={transactionData.amount}
                                                       currency={transactionData.currency}/></b>
                                }}
                                defaultMessage="По данной операции доступна частичная отмена. Максимальная сумма {amount}. Время отмены зависит от банка-эмитента и, как правило, происходит в течение часа."
                            />
                        </p>
                        <div className={classes.CancelWrap}>
                            <InputAmountCurrencyHelper
                                onChange={(val) => setAmount(val.amount)}
                                value={amount}
                                currency={[transactionData.currency]}
                                maxValue={transactionData.amount}
                                placeholder={transactionData.amount}
                                label={<FormattedMessage id="FieldsHelper.label.amount" defaultMessage="Сумма"/>}
                                changeMessage={<FormattedMessage id="FieldsHelper.error.onlyNumbersAmount"
                                                                 defaultMessage="Сумма содержит только цифры и знак «.». Например: 100.20"/>}
                                blurMessage={<FormattedMessage id="FieldsHelper.error.checkAmount"
                                                               defaultMessage="С суммой что-то не так. Проверьте и попробуйте еще раз. Например: 100.20"/>}
                                isDisabled={cancelInProcess.inProcess}
                            />
                        </div>
                    </Fragment>
                ) : (
                    <FormattedMessage
                        id="TransactionsTable.text.paymentReversal"
                        values={{
                            amount: <b><Amount amount={transactionData.amount} currency={transactionData.currency}/></b>
                        }}
                        defaultMessage="Будет осуществлена отмена платежа на сумму {amount}. Время отмены зависит от банка-эмитента и, как правило, происходит в течение часа."
                    />
                )}
            </Modal>

            <div className={classes.Card}>
                <div className={classes.Table}>
                    <table>
                        <thead>
                        <tr>
                            <th><FormattedMessage id="TransactionsTable.table.date" defaultMessage="Дата"/></th>
                            <th><FormattedMessage id="TransactionsTable.table.payer" defaultMessage="Плательщик"/></th>
                            <th><FormattedMessage id="TransactionsTable.table.amount" defaultMessage="Сумма"/></th>
                            <th><FormattedMessage id="TransactionsTable.table.project" defaultMessage="Проект"/></th>
                            <th/>
                        </tr>
                        </thead>
                        <tbody>
                        {transactions && transactions.length > 0 ? (
                            isLoading ? (
                                transactions.map((row) => (
                                    <TableRow
                                        key={row.id}
                                        token={token}
                                        data={row}
                                        adminPrivileges={adminPrivileges}
                                        onTransactionCancel={onTransactionCancel}
                                        cancelTransactionData={cancelTransactionData}
                                        cancelInProcess={cancelInProcess}
                                    />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={5} style={{textAlign: "center"}}>
                                        <Loader/>
                                    </td>
                                </tr>
                            )
                        ) : (
                            <Empty/>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </Fragment>
    );
}

export default TransactionsTable;



// WEBPACK FOOTER //
// ./src/Components/TransactionsTable/index.js